module.exports = __webpack_public_path__ + "static/preview-9cd6ae260b69acf66c387c4d7b733f95.jpg";